import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";
import { Task } from "./useTaskCreateMutation";

type SharePointAttechmentAddResponse = ResponseType<Task>;

function useSharePointAttechmentAddMutation(taskId?: string) {
  const mutation = useMutation<
    AxiosResponseAndError<SharePointAttechmentAddResponse>["response"],
    AxiosResponseAndError<SharePointAttechmentAddResponse>["error"],
    {
      file: {
        url: string;
        name: string;
      }[];
      tempId: string;
    }
  >({
    mutationFn: (data) =>
      ApiRequest.post<SharePointAttechmentAddResponse>(
        `${requestURLs.task}sharepoint-attachment/${data.tempId ? data.tempId : taskId}`,
        data
      ),
  });

  return mutation;
}

export default useSharePointAttechmentAddMutation;
